import { Controller } from "@hotwired/stimulus"
import { apiJson, formatApiErrorDetail } from "../lib/api_errore"
import { VisiteTrattenute, riparti } from "../lib/visite_trattenute"

// Il modulo «Richiedi una demo» di Landing.js (submit, 31a5bd1:121-139): POST /api/demo-request
// { name, email, company, project_type, message } con X-CSRF-Token (apiJson); a buon fine il modulo diventa
// `contact-success`, il toast «Richiesta inviata!», e il tracciamento delle conversioni (dataLayer sempre,
// gtag solo se definito); altrimenti il toast col dettaglio o «Invio non riuscito, riprova».
// Finché la richiesta è in volo le visite Turbo sono trattenute (come la newsletter).
export default class extends Controller {
  static targets = ["modulo", "nome", "email", "azienda", "tipo", "messaggio", "invio", "icona", "attesa", "fatto"]

  connect() {
    this.visite = new VisiteTrattenute()
    this.occupato = false
  }

  disconnect() {
    this.visite.lascia()
  }

  async invia(event) {
    event.preventDefault()
    if (this.occupato) return
    this.occupato = true
    this.visite.trattieni()
    this.disegna()
    const progetto = this.tipoTarget.value
    let fatto = false
    try {
      await apiJson("/api/demo-request", {
        method: "POST",
        body: { name: this.nomeTarget.value, email: this.emailTarget.value, company: this.aziendaTarget.value,
                project_type: progetto, message: this.messaggioTarget.value },
      })
      fatto = true
      window.toast?.success?.("Richiesta inviata!")
      // conversion tracking (no-op until an analytics tag is configured)
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: "demo_request", project_type: progetto })
      if (typeof window.gtag === "function") window.gtag("event", "generate_lead", { form: "demo" })
    } catch (e) {
      window.toast?.error?.(formatApiErrorDetail(e.detail) || "Invio non riuscito, riprova")
    } finally {
      this.occupato = false
    }
    if (this.element.isConnected) {
      if (fatto) this.moduloTarget.replaceWith(this.fattoTarget.content.cloneNode(true))
      else this.disegna()
    }
    const url = this.visite.rilascia()
    if (url) riparti(url)
  }

  disegna() {
    this.invioTarget.disabled = this.occupato
    this.iconaTarget.classList.toggle("hidden", this.occupato)
    this.attesaTarget.classList.toggle("hidden", !this.occupato)
  }
}
